/**
 * Extracts the first letter from each string in an array.
 *
 * @param {string[]} stringsArray - An array of strings from which the first letter will be extracted.
 * @returns {string[]} An array containing the first letter of each string from the input array. If a string is empty or contains only whitespace, an empty string is returned for that entry.
 */
export function getFirstLetters(stringsArray: (string | undefined)[]): string[] {
  return stringsArray.map((string) => (string?.trim() ? string[0] : ""))
}
